import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const PageWrapper = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: sans-serif;
  color: #000;
`;

export const ContentWrapper = styled.div`
  text-align: center;

  animation: ${fadeIn} 1s ease-in-out forwards;
`;

export const CompanyName = styled.h1`
  font-size: 3rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
`;

export const Description = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  animation: ${fadeIn} 1s ease-in-out forwards;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`;

export const LaunchDate = styled.p`
  font-size: 1rem;
  color: gray;
  opacity: 0.5;
  animation: ${fadeIn} 1s ease-in-out forwards;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const LogoContainer = styled.div`
//   max-width: 500px;
  display: flex;
  align-items: center;
`;

export const LogoImg = styled.img`
  width: 100%;
  height: auto;
`;